import React, { useEffect } from "react";
import "./Confirm_delivery_add_offcanvas.css";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrderAddress } from "../../../../features/order/orderSlice";

const Confirm_delivery_add_offcanvas = ({
  orderAddress,
  setOrderAddress,
  show,
  onHide,
  ...props
}) => {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allAddress = useSelector((state) => state.order.allOrdersAddress);
  useEffect(() => {
    // if (user?.id) {
    dispatch(getAllOrderAddress());
    // }
  }, [dispatch]);

  const address = allAddress?.data?.[0];

  const formattedAddress = [
    address?.building,
    address?.floor,
    address?.apartment,
    address?.street,
    address?.direction,
    address?.Users_Address_Detail?.City?.name,
    address?.Users_Address_Detail?.State?.name,
    address?.Users_Address_Detail?.Country?.name,
    address?.Users_Address_Detail?.Pincode?.name,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      {["end"].map((placement, idx) => (
        <Offcanvas
          className="Confirm_delivery_add_offcanvas"
          show={show}
          onHide={onHide}
          {...props}
          key={idx}
          placement={placement}
          name={placement}
        >
          <Offcanvas.Body>
            <div className="addbox">
              <div className="headdiv">
                <h6 className="modhed">Confirm Delivery Address</h6>

                <img
                  className="closeoffcanvas"
                  src={
                    process.env.PUBLIC_URL + "/assets/images/icons/close.png"
                  }
                  onClick={onHide} // Add this onClick handler
                  style={{ cursor: "pointer" }}
                  type="button"
                />
              </div>

              <div className="addbody">
                <p className="addpoint">
                  <img
                    className="appicn"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/icons/Apartment.png"
                    }
                  />
                  Apartment
                </p>
                <p className="addp">
                  {allAddress?.data?.length > 0
                    ? formattedAddress
                    : "No Address Found"}
                </p>

                <div className="row mt-4">
                  <div className="col-6">
                    <Light_Black_Btn
                      onClick={() => {
                        navigate("/saved-address");
                      }}
                      btnText={allAddress?.data?.length > 0 ? "Update Address" : "Add New Address"}
                    />
                  </div>
                  <div className="col-6">
                    <Pink_Btn
                      btnText={"Proceed"}
                      onClick={() => {
                        if (allAddress?.data?.length > 0) {
                          navigate("/checkout");
                        } else {
                          setError("Please add address before placing order");
                        }
                      }}
                    />
                    <p style={{ color: "red" }}>{error}</p>
                  </div>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      ))}
    </>
  );
};

export default Confirm_delivery_add_offcanvas;
